import { FC } from 'react';
import { GroupWrap } from 'src/components/group-wrap';
import { Link } from 'src/components/navigation/link';
import { Successful } from 'src/hooks/use-axios';
import { ShipperPlatformIdsRequest } from 'src/pages/shippers/use-shipper-platform-ids';

export const ShipperNavigationBar: FC<{
  shipperPlatformIds: Successful<ShipperPlatformIdsRequest>;
}> = ({ shipperPlatformIds }) => {
  const shipperRefId = shipperPlatformIds.response.data.referenceId.toString();
  return (
    <GroupWrap
      gap={2}
      data-testid="secondary-nav"
      alignItems="center"
      flexDirection="row"
    >
      <Link to={`/shippers/${shipperRefId}/documents/from`} mode="secondary">
        From Shipper
      </Link>
      <Link to={`/shippers/${shipperRefId}/documents/to`} mode="secondary">
        To Shipper
      </Link>
    </GroupWrap>
  );
};
